import * as actionTypes from "./actionTypes";

const initSelectedParkingState = () => ({
    slotsData: {
        loading: false,
        error: undefined,
        categoryDataIsCollapsed: true,

        totalSlotsData: {
            parkingSlots: "- - -",
            freeSlots: "- - -",
            occupiedSlots: "- - -",
        },

        categoriesData: []
    },

    changeCategoryModal: {
        open: false,
        loadingRequest: false,
        
        requestWasSuccessful: false,

        error: undefined,
        selectedSlot: {
            id: undefined,
            name: undefined,
            originalCategory: undefined,
            selectedCategory: undefined,
            slotsData: undefined
        }
    },

    table: {
        loading: false,
        error: undefined,

        data: [],
        totalElements: undefined,
        currentPage: undefined,
        totalPages: undefined,
        pageSize: undefined,
        sort: {
            property: undefined,
            direction: undefined
        },

        searchFields: {
            universalSearch: undefined,

            slot: undefined,
            floor: undefined,
            status: undefined,
            category: undefined
        },
    },

    graph: {
        loading: false,
        error: undefined,

        data: [],

        searchFields: {
            slot: undefined,
            floor: undefined,
            category: undefined,
            startTime: undefined,
            endTime: undefined,
            startWorkingHours: undefined,
            endWorkingHours: undefined
        }
    },
});

const initialState = {

    parkingList: {
        loading: false,
        error: undefined,

        availableParkings: []
    },

    searchFieldsData: {
        loading: false,
        error: undefined,

        slotData: [],
        floorData: [],
        categoryData: [],
        categoriesAllData: [],
        statusData: []
    },

    selectedParking: initSelectedParkingState(),
};

const parkingReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.GET_PARKING_LIST_REQUEST:
            return {
                ...state,
                parkingList: {
                    ...state.parkingList,
                    loading: true,
                    error: undefined,
                }
            };
        case actionTypes.GET_PARKING_LIST_SUCCESS:
            return {
                ...state,
                parkingList: {
                    ...state.parkingList,
                    loading: false,
                    error: undefined,
                    availableParkings: payload
                }
            };
        case actionTypes.GET_PARKING_LIST_FAILED:
            return {
                ...state,
                parkingList: {
                    ...state.parkingList,
                    loading: false,
                    error: payload,
                }
            };
        case actionTypes.LOAD_PARKING_DATA_REQUEST:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    slotsData: {
                        ...state.selectedParking.slotsData,
                        error: undefined,
                        loading: true,
                    }
                }
            };
        case actionTypes.LOAD_PARKING_DATA_SUCCESS:
            const { totalSlotsData, categoriesData } = payload;
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    slotsData: {
                        ...state.selectedParking.slotsData,
                        loading: false,
                        error: undefined,
                        totalSlotsData: totalSlotsData,
                        categoriesData: categoriesData
                    }
                }
            };
        case actionTypes.LOAD_PARKING_DATA_FAILED:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    slotsData: {
                        ...state.selectedParking.slotsData,
                        loading: false,
                        error: payload
                    }
                }
            };
        case actionTypes.COLLAPSE_SPOTS_INFO_CATEGORIES:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    slotsData: {
                        ...state.selectedParking.slotsData,
                        categoryDataIsCollapsed: !state.selectedParking.slotsData.categoryDataIsCollapsed
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_TABLE_DATA_REQUEST:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    table: {
                        ...state.selectedParking.table,
                        loading: true,
                        error: undefined
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_TABLE_DATA_SUCCESS:
            const {
                content: tableData,
                numberOfElements,
                totalElements,
                pageNumber,
                totalPages,
                sort,
                size
            } = payload;
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    table: {
                        ...state.selectedParking.table,
                        loading: false,
                        error: undefined,

                        data: tableData,
                        numberOfElements,
                        totalElements,
                        pageNumber,
                        totalPages,
                        pageSize: size,
                        sort: {
                            property: sort.property,
                            direction: sort.direction
                        }
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_TABLE_DATA_FAILED:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    table: {
                        ...state.selectedParking.table,
                        loading: false,
                        error: payload
                    }
                }
            };
        case actionTypes.TABLE_SEARCH_FIELD_CHANGED:
            const {
                fieldId: tableSearchFieldId,
                value: tableSearchFieldValue
            } = payload;
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    table: {
                        ...state.selectedParking.table,
                        searchFields: {
                            ...state.selectedParking.table.searchFields,
                            [tableSearchFieldId]: tableSearchFieldValue
                        }
                    }
                }
            };
        case actionTypes.TABLE_SEARCH_FIELD_CLEAN_ALL:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    table: {
                        ...state.selectedParking.table,
                        searchFields: {
                            ...state.selectedParking.table.searchFields,
                            universalSearch: undefined,
                            slot: undefined,
                            floor: undefined,
                            status: undefined,
                            category: undefined
                        }
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_GRAPH_DATA_REQUEST:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    graph: {
                        ...state.selectedParking.graph,
                        loading: true,
                        error: undefined
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_GRAPH_DATA_SUCCESS:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    graph: {
                        ...state.selectedParking.graph,
                        loading: false,
                        error: undefined,

                        data: payload,
                    }
                }
            };
        case actionTypes.LOAD_PARKING_SPOTS_GRAPH_DATA_FAILED:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    graph: {
                        ...state.selectedParking.graph,
                        loading: false,
                        error: payload
                    }
                }
            };
        case actionTypes.GRAPH_SEARCH_FIELD_CHANGED:
            const {
                fieldId: graphSearchFieldId,
                value: graphSearchFieldValue
            } = payload;
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    graph: {
                        ...state.selectedParking.graph,
                        searchFields: {
                            ...state.selectedParking.graph.searchFields,
                            [graphSearchFieldId]: graphSearchFieldValue
                        }
                    }
                }
            };
        case actionTypes.GRAPH_SEARCH_FIELD_CLEAN_ALL:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    graph: {
                        ...state.selectedParking.graph,
                        searchFields: {
                            ...state.selectedParking.graph.searchFields,
                            slot: undefined,
                            floor: undefined,
                            status: undefined,
                            category: undefined,
                            startTime: undefined,
                            endTime: undefined,
                            startWorkingHours: undefined,
                            endWorkingHours: undefined
                        }
                    }
                }
            };
        case actionTypes.LOAD_SEARCH_FIELDS_DATA_REQUEST:
            return {
                ...state,
                searchFieldsData: {
                    ...state.searchFieldsData,
                    loading: true,
                    error: undefined
                }
            };
        case actionTypes.LOAD_SEARCH_FIELDS_DATA_SUCCESS:
            const { slotData, floorData, categoryData, categoriesAllData, statusData } = payload;
            return {
                ...state,
                searchFieldsData: {
                    ...state.searchFieldsData,
                    loading: false,
                    error: undefined,

                    slotData,
                    floorData,
                    categoryData,
                    categoriesAllData,
                    statusData
                }
            };
        case actionTypes.LOAD_SEARCH_FIELDS_DATA_FAILED:
            return {
                ...state,
                searchFieldsData: {
                    ...state.searchFieldsData,
                    loading: false,
                    error: payload
                }
            };
        case actionTypes.RESET_SELECTED_PARKING:
            return {
                ...state,
                selectedParking: initSelectedParkingState()
            }
        case actionTypes.CHANGE_SPOT_CATEGORY_REQUEST:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        ...state.selectedParking.changeCategoryModal,
                        error: undefined,
                        loadingRequest: true,
                        requestWasSuccessful: false
                    }
                }
            };
        case actionTypes.CLOSE_SPOT_CONFIGURATION_MODAL:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        open: false,
                        loadingRequest: false,
                        requestWasSuccessful: false,
                        selectedSlot: {
                            id: undefined,
                            name: undefined,
                            originalCategory: undefined,
                            selectedCategory: undefined,
                            slotsData: undefined
                        }
                    }
                }
            };
        case actionTypes.CHANGE_SPOT_CATEGORY_SUCCESS:
            const { slotId, category } = payload;
            const { categoryData : catData } = state.searchFieldsData;

            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        open: false,
                        loadingRequest: false,
                        requestWasSuccessful: true,
                        selectedSlot: {
                            id: undefined,
                            name: undefined,
                            originalCategory: undefined,
                            selectedCategory: undefined,
                            slotsData: undefined
                        }
                    },
                    table: {
                        ...state.selectedParking.table,
                        data: state.selectedParking.table.data.map(d => {
                            if(d.id !== slotId) {
                                return d;
                            } else {
                                return {
                                    ...d,
                                    category: catData.find(c => c.id === category)
                                }
                            }
                        })
                    }
                }
            };
        case actionTypes.CHANGE_SPOT_CATEGORY_FAILED:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        ...state.selectedParking.changeCategoryModal,
                        loadingRequest: false,
                        requestWasSuccessful: false,
                        error: payload
                    }
                }
            };
        case actionTypes.OPEN_SPOT_CONFIGURATION_MODAL:
            const existingSpot = state.selectedParking.table.data.find(d => d.id === payload);
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        open: true,
                        loadingRequest: false,
                        requestWasSuccessful: false,
                        error: undefined,
                        selectedSlot: {
                            id: existingSpot.id,
                            name: existingSpot.name,
                            originalCategory: existingSpot.category,
                            selectedCategory: undefined,
                            slotsData: existingSpot
                        }
                    }
                }
            };
        case actionTypes.CHANGE_SELECTED_CATEGORY:
            return {
                ...state,
                selectedParking: {
                    ...state.selectedParking,
                    changeCategoryModal: {
                        ...state.selectedParking.changeCategoryModal,
                        selectedSlot: {
                            ...state.selectedParking.changeCategoryModal.selectedSlot,
                            selectedCategory: payload
                        }
                    }
                }
            };
        default:
            return state;
    }
};

export default parkingReducer;